import { gql } from "generated-graphql";

export const GET_STAFF_CERS_TRUE_UP_SUBMITTALS = gql(`
  query StaffCersTrueUpSubmittals($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    staffCersTrueUpSubmittals(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        id
        cersFacilityId
        organizationName
        facilityName
        siteAddress
        city
        zipCode
        localRegulatorDistrict
        submittedDate
        submittedBy
        moduleDecisions {
          id
          module
          status
          decisionDate
          cupaCode
          rawComment
          regulatorName
          regulatorEmail
          regulatorPhone
          resolution { findingId status resolutionType resolvedAt revisionReportId }
        }
      }
      count
    }
  }
`);

// Count-only variant for the Coverage stat card: passes pageSize 0 so the server
// skips hydrating a full submittal + its module decisions just to read the count.
export const GET_STAFF_CERS_TRUE_UP_SUBMITTALS_COUNT = gql(`
  query StaffCersTrueUpSubmittalsCount {
    staffCersTrueUpSubmittals(pageSize: 0) {
      count
    }
  }
`);
